<mat-form-field
  [class.invalid-field]="!form.valid && submitted"
  (click)="toggleMatPicker()"
  appearance="outline"
  >
  @if (label) {
    <mat-label>
      @if (icon) {
        <tidy-image [src]="icon" class="icon outline-field-label-icon" />
      }
      <tidy-text [body]="label" />
    </mat-label>
  }

  <input
    matInput
    [matDatepicker]="picker"
    (dateChange)="changeDate($event)"
    [value]="value"
    [min]="minDate"
    [placeholder]="placeholder"
    readonly
    />

  <mat-datepicker-toggle matSuffix [for]="picker">
    <div class="mat-select-arrow-wrapper" matDatepickerToggleIcon>
      <div class="mat-select-arrow"></div>
    </div>
  </mat-datepicker-toggle>

  <mat-datepicker
    #picker
    [opened]="calendarOpened"
    (closed)="calendarClosed()"
  />
</mat-form-field>

@if (!form.valid && submitted) {
  <tidy-error-message [text]="errorMessage" />
}
